import { PUBLIC_API_ENDPOINT } from '../constants/platform';

/**
 * TTS công khai dùng chung cho các phần chèn OBS (donate alert, hỏi đáp AI…): proxy Google TTS
 * ở payment-service (giữ khoá phía server), không cần đăng nhập. Trả về `Audio` đã nạp sẵn dữ
 * liệu base64, hoặc `null` nếu mạng lỗi / máy chủ không trả âm thanh — gọi nơi dùng tự quyết định
 * phương án dự phòng (hẹn giờ ẩn thay vì chờ mãi).
 */
export const synthesizeSpeech = async (
  text: string,
  opts?: { voice?: string; speakingRate?: number }
): Promise<HTMLAudioElement | null> => {
  try {
    // Giọng và tốc độ chỉ gửi khi khác mặc định (máy chủ chỉ nhận giọng, tốc độ trong danh sách cho phép).
    const body: Record<string, unknown> = { text };
    if (opts?.voice) body.voice = opts.voice;
    if (opts?.speakingRate && opts.speakingRate !== 1) body.speakingRate = opts.speakingRate;
    const res = await fetch(`${PUBLIC_API_ENDPOINT}/v1/payment-service/public/tts/synthesize`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    return data?.audioContent ? new Audio(`data:audio/mp3;base64,${data.audioContent}`) : null;
  } catch {
    return null;
  }
};
